"use client";

import { Spinner } from "design-system/spinner";
import { AgoraLogo } from "@/components/custom/svgs/agora-logo";

export function ErrorLayout({
  children,
  isLoading = false,
  message,
  title,
}: {
  children?: React.ReactNode;
  isLoading?: boolean;
  message: string;
  title: string;
}) {
  return (
    <div className="relative m-auto min-h-[100vh] w-full max-w-md flex-col items-center justify-center">
      <div className="flex h-28 items-center justify-center">
        <AgoraLogo className="fill-foreground" height={28} />
      </div>

      <div className="flex flex-col gap-5 text-center">
        {title && <div className="ausd-heading-xl">{title}</div>}

        {message && <div className="ausd-text-body">{message}</div>}

        {isLoading && (
          <div className="text-center">
            <Spinner className="size-8" />
          </div>
        )}
      </div>

      {children && children}
    </div>
  );
}
